import { useContext } from 'react'

import ConsentContext from 'contexts/ConsentContext'

const useConsent = () => {
  const context = useContext(ConsentContext)

  if (context === undefined) {
    throw new Error('useConsent must be used within a ConsentContext.Provider')
  }

  return {
    activeStep: context.activeStep,
    backStep: context.backStep,
    counter: context.counter,
    dataConsentForm: context.dataConsentForm,
    isConsentLoading: context.isConsentLoading,
    lastActiveStep: context.lastActiveStep,
    nextDisabled: context.nextDisabled,
    nextStep: context.nextStep,
    reloadOptions: context.reloadOptions,
    setActiveStep: context.setActiveStep,
    setDataConsentForm: context.setDataConsentForm,
    setIsConsentLoading: context.setIsConsentLoading,
    setLastActiveStep: context.setLastActiveStep,
    setNextDisabled: context.setNextDisabled,
    setToNextStep: context.setToNextStep,
    toNextStep: context.toNextStep,
    toStep: context.toStep,
  }
}

export default useConsent
